/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_2_TitleInputs */

const et_case_2_title = /** @type {(inputs: Case_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10x orgaaniline kasv – 10 200 külastajat kuus 6 kuuga`)
};

const en_case_2_title = /** @type {(inputs: Case_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10x organic growth to 10,200 monthly visitors in 6 months`)
};

/**
* | output |
* | --- |
* | "10x organic growth to 10,200 monthly visitors in 6 months" |
*
* @param {Case_2_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const case_2_title = /** @type {((inputs?: Case_2_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_2_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_case_2_title(inputs)
	return en_case_2_title(inputs)
});